import f from "supercluster";
import { useMemo as c, useReducer as g, useEffect as C, useCallback as r } from "react";
import { useMapViewport as x } from "./use-map-viewport.js";
function h(o, s) {
  const e = c(() => new f(s), [s]), [n, i] = g((t) => t + 1, 0);
  C(() => {
    e.load(o.features), i();
  }, [e, o]);
  const { bbox: u, zoom: a } = x({ padding: 100 }), l = c(() => !e || n === 0 ? [] : e.getClusters(u, a), [n, e, u, a]), m = r((t) => e.getChildren(t), [e]), p = r((t) => e.getLeaves(t, 1 / 0), [e]), d = r(
    (t) => e.getClusterExpansionZoom(t),
    [e]
  );
  return {
    clusters: l,
    getChildren: m,
    getLeaves: p,
    getClusterExpansionZoom: d
  };
}
export {
  h as useSupercluster
};
